
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91slug_93bwUncZyOGRBZ90BQUumVwGPVB_g_8uosoocZQn7N7pYMeta } from "/home/bun/app/app/pages/members/working-groups/[slug].vue?macro=true";
import { default as _91slug_939YEgZTizY1i58czc2fYth_JM7CGbpD_piR8T4c9UTR4Meta } from "/home/bun/app/app/pages/conferences/[slug].vue?macro=true";
export default [
  {
    name: "publications-position-papers-p-page",
    path: "/publications/position-papers/p/:page()",
    component: () => import("/home/bun/app/app/pages/publications/position-papers/p/[page].vue")
  },
  {
    name: "about-history-presidents",
    path: "/about/history/presidents",
    component: () => import("/home/bun/app/app/pages/about/history/presidents.vue")
  },
  {
    name: "members-login-forgot",
    path: "/members/login/forgot",
    meta: {"middleware":"logged-user"},
    component: () => import("/home/bun/app/app/pages/members/login/forgot.vue")
  },
  {
    name: "members-login-reset",
    path: "/members/login/reset",
    meta: {"middleware":"reset-password"},
    component: () => import("/home/bun/app/app/pages/members/login/reset.vue")
  },
  {
    name: "about-federations-slug",
    path: "/about/federations/:slug()",
    component: () => import("/home/bun/app/app/pages/about/federations/[slug].vue")
  },
  {
    name: "members-events-slug",
    path: "/members/events/:slug()",
    meta: {"middleware":"private-area"},
    component: () => import("/home/bun/app/app/pages/members/events/[slug].vue")
  },
  {
    name: _91slug_93bwUncZyOGRBZ90BQUumVwGPVB_g_8uosoocZQn7N7pYMeta?.name,
    path: "/members/working-groups/:slug()",
    meta: {"middleware":"private-area"},
    component: () => import("/home/bun/app/app/pages/members/working-groups/[slug].vue"),
    children: [
  {
    name: "members-working-groups-slug-meetings",
    path: "meetings",
    component: () => import("/home/bun/app/app/pages/members/working-groups/[slug]/meetings.vue")
  },
  {
    name: "members-working-groups-slug",
    path: "",
    component: () => import("/home/bun/app/app/pages/members/working-groups/[slug]/index.vue")
  }
]
  },
  {
    name: "news-p-page",
    path: "/news/p/:page()",
    component: () => import("/home/bun/app/app/pages/news/p/[page].vue")
  },
  {
    name: "publications-annual-reports-slug",
    path: "/publications/annual-reports/:slug()",
    component: () => import("/home/bun/app/app/pages/publications/annual-reports/[slug].vue")
  },
  {
    name: "publications-bookshop-slug",
    path: "/publications/bookshop/:slug()",
    component: () => import("/home/bun/app/app/pages/publications/bookshop/[slug].vue")
  },
  {
    name: "about-history",
    path: "/about/history",
    component: () => import("/home/bun/app/app/pages/about/history/index.vue")
  },
  {
    name: "about-partners",
    path: "/about/partners",
    component: () => import("/home/bun/app/app/pages/about/partners.vue")
  },
  {
    name: "about-who-we-are",
    path: "/about/who-we-are",
    component: () => import("/home/bun/app/app/pages/about/who-we-are.vue")
  },
  {
    name: "checkout-conference",
    path: "/checkout/conference",
    meta: {"middleware":"optional-area"},
    component: () => import("/home/bun/app/app/pages/checkout/conference.vue")
  },
  {
    name: "checkout-success",
    path: "/checkout/success",
    component: () => import("/home/bun/app/app/pages/checkout/success.vue")
  },
  {
    name: "members-circular-letters",
    path: "/members/circular-letters",
    meta: {"middleware":"private-area"},
    component: () => import("/home/bun/app/app/pages/members/circular-letters.vue")
  },
  {
    name: "members-login",
    path: "/members/login",
    meta: {"middleware":"logged-user"},
    component: () => import("/home/bun/app/app/pages/members/login/index.vue")
  },
  {
    name: "members-logout",
    path: "/members/logout",
    component: () => import("/home/bun/app/app/pages/members/logout.vue")
  },
  {
    name: "members-profile",
    path: "/members/profile",
    meta: {"middleware":"private-area"},
    component: () => import("/home/bun/app/app/pages/members/profile.vue")
  },
  {
    name: "policies-legal-notice",
    path: "/policies/legal-notice",
    component: () => import("/home/bun/app/app/pages/policies/legal-notice.vue")
  },
  {
    name: "policies-privacy-policy",
    path: "/policies/privacy-policy",
    component: () => import("/home/bun/app/app/pages/policies/privacy-policy.vue")
  },
  {
    name: "publications-annual-reports",
    path: "/publications/annual-reports",
    component: () => import("/home/bun/app/app/pages/publications/annual-reports/index.vue")
  },
  {
    name: "publications-bookshop",
    path: "/publications/bookshop",
    component: () => import("/home/bun/app/app/pages/publications/bookshop/index.vue")
  },
  {
    name: "publications-position-papers",
    path: "/publications/position-papers",
    component: () => import("/home/bun/app/app/pages/publications/position-papers/index.vue")
  },
  {
    name: "publications-statistics",
    path: "/publications/statistics",
    component: () => import("/home/bun/app/app/pages/publications/statistics.vue")
  },
  {
    name: "advocacy-theme",
    path: "/advocacy/:theme()",
    component: () => import("/home/bun/app/app/pages/advocacy/[theme].vue")
  },
  {
    name: _91slug_939YEgZTizY1i58czc2fYth_JM7CGbpD_piR8T4c9UTR4Meta?.name,
    path: "/conferences/:slug()",
    component: () => import("/home/bun/app/app/pages/conferences/[slug].vue"),
    children: [
  {
    name: "conferences-slug-accommodation",
    path: "accommodation",
    component: () => import("/home/bun/app/app/pages/conferences/[slug]/accommodation.vue")
  },
  {
    name: "conferences-slug-gallery",
    path: "gallery",
    component: () => import("/home/bun/app/app/pages/conferences/[slug]/gallery.vue")
  },
  {
    name: "conferences-slug-links",
    path: "links",
    component: () => import("/home/bun/app/app/pages/conferences/[slug]/links.vue")
  },
  {
    name: "conferences-slug-programme",
    path: "programme",
    component: () => import("/home/bun/app/app/pages/conferences/[slug]/programme.vue")
  },
  {
    name: "conferences-slug-registration",
    path: "registration",
    meta: {"middleware":"optional-area"},
    component: () => import("/home/bun/app/app/pages/conferences/[slug]/registration.vue")
  },
  {
    name: "conferences-slug-speakers",
    path: "speakers",
    component: () => import("/home/bun/app/app/pages/conferences/[slug]/speakers.vue")
  },
  {
    name: "conferences-slug-workshop",
    path: "workshop",
    component: () => import("/home/bun/app/app/pages/conferences/[slug]/workshop.vue")
  },
  {
    name: "conferences-slug",
    path: "",
    component: () => import("/home/bun/app/app/pages/conferences/[slug]/index.vue")
  }
]
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/bun/app/app/pages/news/[slug].vue")
  },
  {
    name: "conferences",
    path: "/conferences",
    component: () => import("/home/bun/app/app/pages/conferences/index.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    component: () => import("/home/bun/app/app/pages/contacts/index.vue")
  },
  {
    name: "members",
    path: "/members",
    meta: {"middleware":"private-area"},
    component: () => import("/home/bun/app/app/pages/members/index.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/home/bun/app/app/pages/news/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/home/bun/app/app/pages/search.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/bun/app/app/pages/index.vue")
  }
]